/**
 * Store payload keys owned by Mapal OS, including the aliases used across the store forms
 */
const MOS_OWNED_STORE_PAYLOAD_KEYS = [
  'active',
  'additionnalAddress',
  'address',
  'adress',
  'city',
  'country',
  'latitude',
  'locationValue',
  'longitude',
  'name',
  'postCode',
  'telephone',
  'timezone',
];

/**
 * Drop the Mapal OS owned keys from a store update payload, so a stale form value never reaches the API
 */
export const omitMosOwnedStoreFields = (payload, isSyncedFromMos) => {
  if (!isSyncedFromMos) {
    return payload;
  }

  return Object.fromEntries(
    Object.entries(payload).filter(([key]) => !MOS_OWNED_STORE_PAYLOAD_KEYS.includes(key)),
  );
};
